import React from 'react'
import PropTypes from 'prop-types'
import { useLaneEditor } from './LaneEditor.logic.js'
import { LaneEditorView } from './LaneEditor.view.jsx'

const LaneEditor = ({ lane, children }) => {
  const { isVisible, toggleEditor, closeEditor, propLane } = useLaneEditor(lane)

  return (
    <LaneEditorView
      isVisible={isVisible}
      propLane={propLane}
      toggleEditor={toggleEditor}
      closeEditor={closeEditor}
    >
      {children}
    </LaneEditorView>
  )
}

LaneEditor.propTypes = {
  lane: PropTypes.object,
  children: PropTypes.any,
}

export default LaneEditor
